var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M38 11.875H0V9.5H38V11.875ZM38 30.875H0V28.5H38V30.875ZM38 21.356H0V19C14.8399 19 23.1601 19 38 19V21.356Z","fill":"#85B336"}));
}

Menu.defaultProps = {"id":"burgerMenu","width":"38","height":"38","viewBox":"0 0 38 38","fill":"none","style":{"cursor":"pointer"}};

module.exports = Menu;

Menu.default = Menu;
